import React, {useEffect, useState} from 'react'
import axios from "axios";
import { useForm } from "react-hook-form";
import Select, {createFilter} from "react-select";
import {useHistory, useLocation} from "react-router-dom";
import {
    checkMasterKeyTermKeysByTermApi,
    getTerminalManagementActivityInfoApi,
    TerminalDataTableListMgmtApi,
    TerminalMgmtApi
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

const MasterKeyTerminalSelected = ({ prevStep, nextStep, handleChange,handleValueChangeEvent, values}) => {



    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const location = useLocation();
    const [data, setData] = useState();
    const [timeZoneLbl, setTimeZoneLbl] = useState();
    const [terminalOptions, setTerminalOptions] = useState([]);
    const [terminalSelectData, setTerminalSelectData] = useState([]);
    const [isServiceIDInserted, setIsServiceIDInserted] = useState(false);
    const [terminalID, setTerminalID] = useState();
    const [pending, setPending] = React.useState(true);
    const history = useHistory();

    useEffect(() => {

        const fetchData = async () => {
            let result = await axios.get(`${checkMasterKeyTermKeysByTermApi}?paramTerminalID=${terminalID?.value}`,{
                mode: 'no-cors' // 'cors' by default
            });
            //console.log(terminalID?.terminalID,"retrieve ",terminalID.value,"--by keys to check if result exists--",result.data.response.length==1)
            setData(result.data.response[0]);
            if(result.data.response.length == 0){
                handleValueChangeEvent('isServiceIDInserted:'+false)
            }else{
                handleValueChangeEvent('isServiceIDInserted:'+true)
            }
        };
        fetchData();
        //handleValueChangeEvent('terminalID:'+terminalID)
    }, [terminalID]);

    const handleTerminalSelectionSelection = async (e) => {
        setTerminalID(e);
        handleValueChangeEvent('terminalID:'+e.value)
        history.push({
            pathname: "/keyManagement/masterKeyBind",
            search: `terminalID=${e.value}`,
        });

    };
    useEffect(() => {

        const fetchResults = async () => {
            let result = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });
            console.log("======= ",result)
            setData(result.data.response);
            setTerminalOptions(result?.data?.response);
            setTerminalID({
                label: result?.data.response?.[0]?.terminalID,
                value: result?.data.response?.[0]?.terminalID,
            });
            setPending(false);
            handleValueChangeEvent('terminalID:'+result?.data.response?.[0]?.terminalID)
        };
        fetchResults();
        return () => {
            setTerminalOptions([]);
        };
    }, []);


    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();
    const onSubmit = (data, e) => {
        e.target.reset(); // reset after form submit
        alert(JSON.stringify(data));
    };

    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };
    const Continue = e => {
        e.preventDefault();
        //handleChange('isServiceIDInserted')
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign: "center"}}>Step 1 of 3</h5>
                <form>
                    <div className="col-md-12">
                        <div className="form-group row">
                            <label className="control-label col-md-4"> Please, select the terminal:</label>
                            <div className="input-group col-md-4">
                                <Select
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    options={terminalOptions}
                                    //onChange={(e) => setSelectedTerminal(e)}
                                    onChange={handleTerminalSelectionSelection}
                                    value={terminalID}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                    <button onClick={ Continue }
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="btn btn-primary"
                    >Next</button>
                </form>
            </div>
        </div>
    )
}

export default MasterKeyTerminalSelected